(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sq-installation-search"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Handle search popup functionality
  const searchPopup = document.querySelector('[data-open-search-popup]');
  
  if (searchPopup) {
    searchPopup.addEventListener('click', function() {
      // Redirect to search page or open search modal
      window.location.href = '/search';
      // Alternatively, you could trigger a custom search modal here
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
